import { Trans } from 'react-i18next';

import { Alert, Collapse, Column, LabeledCheckbox } from 'components/Blocks';
import { HandCoinsIcon } from 'components/Icons';

import { CreateProjectDispatchAction } from '../types';
import { useLang } from 'hooks/lang';

interface MinFeeProps {
  value: boolean;
  dispatch: CreateProjectDispatchAction;
}

export function ReadyToInvoice({ value, dispatch }: MinFeeProps): JSX.Element {
  const { t } = useLang();

  const toggle = () => {
    dispatch({ readyToInvoice: (old) => !old.readyToInvoice });
  };

  return (
    <Column>
      <LabeledCheckbox
        checked={value}
        onChange={toggle}
        label={t('ready-to-invoice-?')}
        labelIcon={HandCoinsIcon}
      />

      <Collapse expanded={value}>
        <Alert>
          <Trans i18nKey="ready-to-invoice-warning" />
        </Alert>
      </Collapse>
    </Column>
  );
}
